import React, { Component } from 'react';
import { exportToCSVFailure, exportToCSVSuccess } from '../../actions/export-report-action-creators';
import { flattenedMessageVolumeCoverageSelector, messageVolumeTableIsExportingGridToCSV } from '../../selectors/message-volume-coverage-selectors';

import MessageVolumeTable from '../../components/policy-progress/message-volume-table';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectedIntervalSelector } from '../../selectors/reports-selectors';

export class MessageVolumeTableContainer extends Component{
    render(){
        const {
            exportToCSVSuccess, exportToCSVFailure, interval, isExportingGridToCSV, messageVolumeCoverageData,
        } = this.props;
        return (
            <MessageVolumeTable
                interval={interval}
                data={messageVolumeCoverageData}
                isExportingGridToCSV={isExportingGridToCSV}
                exportToCSVSuccess={exportToCSVSuccess}
                exportToCSVFailure={exportToCSVFailure} />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        interval: selectedIntervalSelector( state ),
        isExportingGridToCSV: messageVolumeTableIsExportingGridToCSV( state ),
        messageVolumeCoverageData: flattenedMessageVolumeCoverageSelector( state ),
    };
};

MessageVolumeTableContainer.propTypes = {
    exportToCSVFailure: PropTypes.func,
    exportToCSVSuccess: PropTypes.func,
    interval: PropTypes.string.isRequired,
    isExportingGridToCSV: PropTypes.bool,
    messageVolumeCoverageData: PropTypes.array.isRequired,
};

export default connect(
    mapStateToProps,
    { exportToCSVFailure, exportToCSVSuccess }
)( MessageVolumeTableContainer );
